import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Column, Cell } from 'fixed-data-table-2';
import 'fixed-data-table-2/dist/fixed-data-table.css';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import Fab from '@material-ui/core/Fab';
import Badge from '@material-ui/core/Badge';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import PersonIcon from '@material-ui/icons/Person';
import ja from "date-fns/locale/ja";
import './Css/Grid.css';
import DateFnsUtils from '@date-io/date-fns';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import KyDetails from '../KyDetail/Index';

import * as MonthlyMoney from './Saga/MonthlyMoney';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';

const { MuiPickersUtilsProvider, KeyboardDatePicker } = require('@material-ui/pickers');
var moment = require('moment-timezone');

var selctedDate = new Date();

var SortTypes = {
  ASC: 'ASC',
  DESC: 'DESC',
};

function reverseSortDirection(sortDir) {
  return sortDir === SortTypes.DESC ? SortTypes.ASC : SortTypes.DESC;
}

class SortHeaderCell extends React.Component {
  constructor(props) {
    super(props);



    this._onSortChange = this._onSortChange.bind(this);



  }

  render() {
    var { onSortChange, sortDir, children, ...props } = this.props;
    return (
      <Cell {...props} onClick={this._onSortChange}>

        {children} {sortDir ? (sortDir === SortTypes.DESC ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />) : ''}

      </Cell>
    );
  }

  _onSortChange(e) {

    e.preventDefault();

    if (this.props.onSortChange) {
      this.props.onSortChange(
        this.props.columnKey,
        this.props.sortDir ?
          reverseSortDirection(this.props.sortDir) :
          SortTypes.DESC
      );
    }
  }


}
const columns = [
  { key: 'is_installment_payment', name: '', width: 50 },
  {
    key: 'date', name: '期間', width: 210

  },
  { key: 'building_name', name: 'マンスリー名', width: 200 },
  { key: 'Tatemono_Name', name: '建物名', width: 200 },


  { key: 'contractor_name1', name: '契約者', width: 200 },
  { key: 'total_money', name: '契約金', width: 100 },

  { key: 'apply_paiment_type', name: '入金方法', width: 120 },

  { key: 'payment_date', name: '入金日', width: 150, resizable: true },
  { key: 'billing_date', name: '請求日', width: 150 },
  { key: 'billing_closing_date', name: '請求締め日', width: 150 },
  { key: 'remarks', name: '備考', width: 200 },
  { key: 'seikyu', name: '請求書', width: 80 }
]

function test(id, is_installment_payment, mn_installment_payment_id, mn_additional_payment_id) {
  console.log(id);
  if(is_installment_payment == 1){
    //分割請求
    window.open('https://homestation.azurewebsites.net/rentcontractsviewmodels/statement?id=' + id + '&installment=' + mn_installment_payment_id, '_blank');
  } else if(mn_additional_payment_id > 0){
    //追加
    window.open('https://homestation.azurewebsites.net/rentcontractsviewmodels/additional?id=' + id + '&additional=' + mn_additional_payment_id, '_blank');
  }else{
    window.open('https://homestation.azurewebsites.net/rentcontractsviewmodels/statement?id=' + id, '_blank');
  }
  
};

function nyukin(id, is_installment_payment, mn_installment_payment_id, mn_additional_payment_id, props) {
  // ボタンのところを推した時間に切り替える
  // document.getElementById(id).innerHTML = moment(selctedDate).format('YYYY-MM-DD');


  var data = {
    id: id,
    payment_date: selctedDate,
    payment_type: 1,
    is_installment_payment: is_installment_payment,
    mn_installment_payment_id: mn_installment_payment_id,
    mn_additional_payment_id: mn_additional_payment_id,
    type:2,//1:備考 2:入金確認
  }


  console.log(data);

  props.monthly_update(data);
  // rent_contractのpaymant_type を 1 にして payment_dateに現在日時を入れる
};

const Seikyu = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap" }}>
    <button style={{ marginLeft: 22, fontSize: 20 }} class="far fa-file-alt" onClick={() => test(props.monthly_money_search_list[rowIndex]['id'], props.monthly_money_search_list[rowIndex]['is_installment_payment'], props.monthly_money_search_list[rowIndex]['mn_installment_payment_id'], props.monthly_money_search_list[rowIndex]['mn_additional_payment_id'])}></button>
  </Cell>;

const IsInstallmentPayment = ({ column, props, rowIndex }) =>

  <Cell style={{ whiteSpace: "nowrap" }}>
    {props.monthly_money_search_list[rowIndex]['is_installment_payment'] == 1 ? "分割" : props.monthly_money_search_list[rowIndex]['mn_additional_payment_id'] > 0 ? "追加" : ""}
    {/* <button style={{ marginLeft: 22, fontSize: 20 }} class="far fa-file-alt" onClick={() => test(props.monthly_money_search_list[rowIndex]['id'], props.monthly_money_search_list[rowIndex]['is_installment_payment'], props.monthly_money_search_list[rowIndex]['mn_installment_payment_id'], props.monthly_money_search_list[rowIndex]['mn_additional_payment_id'])}></button> */}
  </Cell>;

// 入金方法
// 申込みの際に客が選択している
const Apply_paiment_type = ({ column, props, rowIndex }) =>
  (() => {
    if (props.monthly_money_search_list[rowIndex]['apply_payment_type'] == 1) {
      return "銀行振込"
    } else if (props.monthly_money_search_list[rowIndex]['apply_payment_type'] == 2) {
      return "クレジット"
    } else {
      return "";
    }
  })()


// 入金確認日
const Payment_date = ({ column, props, rowIndex }) =>
  (() => {
    if (props.monthly_money_search_list[rowIndex]['payment_date'] !== null) {
      var date = moment(props.monthly_money_search_list[rowIndex]['payment_date']).format('YYYY-MM-DD');
      return <Cell style={{ whiteSpace: "nowrap" }}>{date}</Cell>
    } else if (props.monthly_money_search_list[rowIndex]['apply_payment_type'] == 1) {
      return <Cell id={props.monthly_money_search_list[rowIndex]['id']} style={{ whiteSpace: "nowrap" }}>
        <input type="button" value="入金確認" class="btn btn-sm btn-info" onClick={() => nyukin(props.monthly_money_search_list[rowIndex]['id'], props.monthly_money_search_list[rowIndex]['is_installment_payment'], props.monthly_money_search_list[rowIndex]['mn_installment_payment_id'], props.monthly_money_search_list[rowIndex]['mn_additional_payment_id'], props)} />
      </Cell>;
    } else {
      return "";
    }
  })()



function onChange(e, id, is_installment_payment, mn_installment_payment_id, mn_additional_payment_id, props) {

  var data = {
    id: id,
    contract_remarks: e.target.value,
    is_installment_payment: is_installment_payment,
    mn_installment_payment_id: mn_installment_payment_id,
    mn_additional_payment_id: mn_additional_payment_id,
    type:1,
  }
  props.monthly_update(data);

}

// 備考
// ここで入力する
const Remarks = ({ column, props, rowIndex }) =>
  (() => {
    if (props.monthly_money_search_list[rowIndex]['contract_remarks']) {
      return <Cell style={{ whiteSpace: "nowrap" }}> <TextField defaultValue={props.monthly_money_search_list[rowIndex]['contract_remarks']} onChange={(e) => onChange(e, props.monthly_money_search_list[rowIndex]['id'], props.monthly_money_search_list[rowIndex]['is_installment_payment'], props.monthly_money_search_list[rowIndex]['mn_installment_payment_id'], props.monthly_money_search_list[rowIndex]['mn_additional_payment_id'], props)} style={{ marginTop: 10 }} id="standard-basic" /></Cell>
    } else {
      return <TextField onChange={(e) => onChange(e, props.monthly_money_search_list[rowIndex]['id'], props.monthly_money_search_list[rowIndex]['is_installment_payment'], props.monthly_money_search_list[rowIndex]['mn_installment_payment_id'], props.monthly_money_search_list[rowIndex]['mn_additional_payment_id'], props)} style={{ marginTop: 10 }} id="standard-basic" />
    }
  })()


const RoomName = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >{props.monthly_money_search_list[rowIndex][column.key]}</Cell>;


const KaiyakuDate = ({ column, props, rowIndex }) =>
  // <Cell style={{ whiteSpace: "nowrap", width: "100%", height: "100%", background: moment(props.seisan_follow_list[rowIndex][column.key]).tz("Asia/Tokyo").format('YYYY/MM/DD') > moment().tz("Asia/Tokyo").format('YYYY/MM/DD') ? "#87cefa" : "#98fb98" }} >
  <Cell style={{ whiteSpace: "nowrap", width: "100%", height: "100%" }} >

    {props.monthly_money_search_list[rowIndex][column.key] ? moment(props.monthly_money_search_list[rowIndex][column.key]).tz("Asia/Tokyo").format('YYYY/MM/DD') : ""}

    <br />{props.monthly_money_search_list[rowIndex].taikyo_yotei_date && moment(props.monthly_money_search_list[rowIndex].taikyo_yotei_date).tz("Asia/Tokyo").format('YYYY/MM/DD') !== moment(props.monthly_money_search_list[rowIndex].kaiyaku_date).tz("Asia/Tokyo").format('YYYY/MM/DD') ? <b>退予 {moment(props.monthly_money_search_list[rowIndex].taikyo_yotei_date).tz("Asia/Tokyo").format('M/DD')} </b> : ""}

    {/* <Badge badgeContent={"次2日"} color="secondary">　</Badge> */}

  </Cell >;

const KaiyakuOwnerRenraku = ({ column, props, rowIndex, update_kaiyaku_owner_renraku, }) => <Cell style={{ width: "100%", height: "100%" }} >
  {props.monthly_money_search_list[rowIndex].changing ? <div style={{ zIndex: 3000, background: "rgba(45,45,45, 0.5)", width: "300px", height: "300px", marginLeft: -15, marginTop: -30 }}></div> :

    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja} >

      <KeyboardDatePicker
        disableToolbar
        variant="inline"
        format="yyyy/MM/dd"
        margin="normal"
        id="date-picker-estimate2"
        autoOk={true}
        // label="始期日"
        onChange={(e, value) => update_kaiyaku_owner_renraku(value, props.monthly_money_search_list[rowIndex].keiyaku_no)}
        name="start_date"
        value={props.monthly_money_search_list[rowIndex].kaiyaku_owner_renraku ? props.monthly_money_search_list[rowIndex].kaiyaku_owner_renraku : null}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}

      // invalidDateMessage={"日付の形式が違います"}
      />
    </MuiPickersUtilsProvider>
  }
</Cell >;


const CompletionOwnerReortAt = ({ column, props, rowIndex, update_completion_owner_report_at, }) => <Cell style={{ width: "100%", height: "100%" }} >
  {props.monthly_money_search_list[rowIndex].changing ? <div style={{ zIndex: 3000, background: "rgba(45,45,45, 0.5)", width: "300px", height: "300px", marginLeft: -15, marginTop: -30 }}></div> :

    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja} >

      <KeyboardDatePicker
        disableToolbar
        variant="inline"
        format="yyyy/MM/dd"
        margin="normal"
        id="date-picker-estimate2"
        autoOk={true}
        // label="始期日"
        onChange={(e, value) => update_completion_owner_report_at(value, props.monthly_money_search_list[rowIndex].keiyaku_no)}
        name="start_date"
        value={props.monthly_money_search_list[rowIndex].completion_owner_report_at ? props.monthly_money_search_list[rowIndex].completion_owner_report_at : null}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}

      // invalidDateMessage={"日付の形式が違います"}
      />
    </MuiPickersUtilsProvider>
  }
</Cell >;

const DateCheck = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap", background: props.monthly_money_search_list[rowIndex][column.key] ? "#f5f5f5" : "pink", width: "100%", height: "100%" }} >{props.monthly_money_search_list[rowIndex][column.key] ? moment(props.monthly_money_search_list[rowIndex][column.key]).tz("Asia/Tokyo").format('YYYY/MM/DD') : ""}</Cell>;


const EstimateCheck = ({ column, props, rowIndex, open_estimate }) =>
  <Cell style={{ whiteSpace: "nowrap", background: props.monthly_money_search_list[rowIndex][column.key] ? "#f5f5f5" : "pink", width: "100%", height: "100%" }} >
    {props.monthly_money_search_list[rowIndex][column.key] ? <div><IconButton onClick={() => open_estimate(props.monthly_money_search_list[rowIndex].keiyaku_no)}><LibraryBooksIcon color="primary" /></IconButton> {moment(props.monthly_money_search_list[rowIndex][column.key]).tz("Asia/Tokyo").format('YYYY/MM/DD')}</div> : ""}</Cell>;



const Owner = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >  <IconButton onClick={() => props.toggle_owner(props.monthly_money_search_list[rowIndex].shoyuusha_id)} >< AssignmentIndIcon color="primary" />  </IconButton> {props.monthly_money_search_list[rowIndex][column.key]}</Cell>;

const Keiyakusha = ({ column, props, rowIndex, onKyopen }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >{props.monthly_money_search_list[rowIndex].ky_no ? <IconButton onClick={() => onKyopen(props.monthly_money_search_list[rowIndex].bk_no, props.monthly_money_search_list[rowIndex].hy_no, props.monthly_money_search_list[rowIndex].ky_no)}>< PersonIcon color="primary" /></IconButton> : ""} {props.monthly_money_search_list[rowIndex][column.key]}</Cell>;

const Shunkou = ({ column, props, rowIndex, onKyopen }) => <Cell style={{ whiteSpace: "nowrap" }} >{props.monthly_money_search_list[rowIndex].shunkou_year && props.monthly_money_search_list[rowIndex].shunkou_month ? props.monthly_money_search_list[rowIndex].shunkou_year + '年' + props.monthly_money_search_list[rowIndex].shunkou_month + "月築" : ""}</Cell>;


const Datebase = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >
    {props.monthly_money_search_list[rowIndex][column.key] ? moment(props.monthly_money_search_list[rowIndex][column.key]).tz("Asia/Tokyo").format('YYYY-MM-DD') : ""}
  </Cell>;


const Base = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >{props.monthly_money_search_list[rowIndex][column.key]}</Cell>;

class CustomerList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: columns,
      reflash: false,

      colSortDirs: {},
      // dataList: new FakeObjectDataListStore(1000000),
      // columnWidths: {
      //   firstName: 240,
      //   lastName: 150,
      //   sentence: 140,
      //   companyName: 60,
      // },
    };




    this._onColumnResizeEndCallback = this._onColumnResizeEndCallback.bind(this);

    this._onSortChange = this._onSortChange.bind(this);

    this.onChangeDate1 = this.onChangeDate1.bind(this);


  }
  _onColumnResizeEndCallback(newColumnWidth, columnKey) {

    let columnsset = this.state.columns.map(function (value) {
      if (value.key === columnKey) {
        value.width = newColumnWidth
      }
      return value
    })

    this.setState({ columns: columnsset })

  }





  _onSortChange(columnKey, sortDir) {

    // alert(columnKey)
    // alert(_defaultSortIndexes.indexOf(columnKey))
    let seisan_follow_search_list = this.props.monthly_money_search_list;
    seisan_follow_search_list.sort((indexA, indexB) => {
      // alert(indexA)
      // alert(indexA[columnKey])
      var valueA = indexA[columnKey];
      var valueB = indexB[columnKey];
      var sortVal = 0;
      if (valueA > valueB) {
        sortVal = 1;
      }
      if (valueA < valueB) {
        sortVal = -1;
      }

      if (!valueA && !valueB) {
        sortVal = 0
      }
      if (!valueA) {
        sortVal = -1
      }
      if (!valueB) {
        sortVal = 1
      }


      if (sortVal !== 0 && sortDir === SortTypes.DESC) {
        sortVal = sortVal * -1;
      }

      this.props.refresh();

      return sortVal;
    });
    this.setState({
      // sortedDataList: new DataListWrapper(sortIndexes, this._dataList),
      colSortDirs: {
        [columnKey]: sortDir,
      },
    });






  }
  onChangeDate1 = (date) => {
    selctedDate = new Date(date);

    this.setState({
      selectedDate: new Date(date),
    });
  };
  render() {

    return (
      <div id="seisanlist">
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            margin="normal"
            id="date-picker-dialog"
            label=""
            format="yyyy/MM/dd"
            value={this.state.selectedDate}
            onChange={this.onChangeDate1}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
          />
        </MuiPickersUtilsProvider>
        ←選択した日付が入金日に登録されます。
        <Table
          rowHeight={45}
          rowsCount={this.props.monthly_money_search_list.length}
          onColumnResizeEndCallback={this._onColumnResizeEndCallback}
          width={window.innerWidth - 110}
          height={100 + this.props.monthly_money_search_list.length * 47}
          headerHeight={40}>
          {columns.map(function (value, i) {
            return <Column
              columnKey={value.key}
              header={<SortHeaderCell
                onSortChange={this._onSortChange}
                sortDir={this.state.colSortDirs[value.key]}
                style={{ whiteSpace: "nowrap" }}>{value.name}</SortHeaderCell>}

              // cell={({ rowIndex, ...props }) => (<Cell style={{ whiteSpace: "nowrap" }} >{this.props.seisan_follow_list[rowIndex][value.key]}</Cell>)}
              cell={({ rowIndex, ...props }) => (

                value.key === "billing_date" || value.key === "billing_closing_date" ? <Datebase column={value} props={this.props} rowIndex={rowIndex}></Datebase>
                :  value.key === "is_installment_payment" ? <IsInstallmentPayment column={value} props={this.props} rowIndex={rowIndex}></IsInstallmentPayment>
                  :  value.key === "seikyu" ? <Seikyu column={value} props={this.props} rowIndex={rowIndex}></Seikyu>
                  : value.key === "apply_paiment_type" ? <Apply_paiment_type column={value} props={this.props} rowIndex={rowIndex}></Apply_paiment_type>
                    : value.key === "room_name" ? <RoomName column={value} props={this.props} rowIndex={rowIndex}></RoomName>
                      : value.key === "payment_date" ? <Payment_date column={value} props={this.props} rowIndex={rowIndex}></Payment_date>
                        : value.key === "kaiyaku_date" ? <KaiyakuDate column={value} props={this.props} rowIndex={rowIndex}></KaiyakuDate>
                          : value.key === "remarks" ? <Remarks column={value} props={this.props} rowIndex={rowIndex}></Remarks>
                            : value.key === "hoshuu_date" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>
                              : value.key === "kagi_uketori_date" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>

                                : value.key === "completion_at" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>
                                  : value.key === "estimate_request" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>
                                    : value.key === "after_check" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>
                                      : value.key === "estimate_receives" ? <EstimateCheck column={value} props={this.props} rowIndex={rowIndex} open_estimate={this.open_estimate}></EstimateCheck>
                                        : value.key === "shoyuusha_name" ? <Owner column={value} props={this.props} rowIndex={rowIndex}></Owner>
                                          : value.key === "kei_name" ? <Keiyakusha column={value} props={this.props} rowIndex={rowIndex} onKyopen={this.onKyopen} ></Keiyakusha>
                                            : value.key === "shunkou" ? <Shunkou column={value} props={this.props} rowIndex={rowIndex} ></Shunkou>

                                              : value.key === "kanri_order_at" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>
                                                : value.key === "kaiyaku_owner_renraku" ? <KaiyakuOwnerRenraku column={value} props={this.props} rowIndex={rowIndex} update_kaiyaku_owner_renraku={this.update_kaiyaku_owner_renraku}></KaiyakuOwnerRenraku>
                                                  : value.key === "completion_owner_report_at" ? <CompletionOwnerReortAt column={value} props={this.props} rowIndex={rowIndex} update_completion_owner_report_at={this.update_completion_owner_report_at}></CompletionOwnerReortAt>
                                                    // : value.key === "seikyu" ? <CompletionOwnerReortAt column={value} props={this.props} rowIndex={rowIndex} update_completion_owner_report_at={this.update_completion_owner_report_at}></CompletionOwnerReortAt>




                                                    : <Base column={value} props={this.props} rowIndex={rowIndex}></Base>
              )}
              width={this.state.columns.filter(a => a.key === value.key)[0].width}
              isResizable={true}
              fixed={value.frozen}

            />
          }, this)}



        </Table >

        <Modal isOpen={this.state.kytoggle} toggle={this.kytoggle} size="xl" fade={false}>

          <ModalHeader toggle={this.kytoggle}>契約情報</ModalHeader>
          {/* <ModalBody> */}
          <KyDetails ky={this.state.ky} />
          {/* </ModalBody> */}
          <ModalFooter>
            {/* <button className="btn btn btn-danger" style={{margin:"5px"}} onClick={this.delete_introductions}>削除する</button>*/}
            {/* <button className="btn btn btn-secondary" style={{ margin: "5px" }} onClick={() => this.props.change_search_modal(false)}>キャンセル</button> */}
          </ModalFooter>
        </Modal >
      </div>
    );
  }
};


//export  default CustomerList;
const mapStateToProps = (state) => {
  return {

    search_modal: state.MonthlyMoney.search_modal,
    // room_details: state.roomsReducer.room_details,
    monthly_money_list: state.MonthlyMoney.monthly_money_list,
    monthly_money_search_list: state.MonthlyMoney.monthly_money_search_list,
  }
}
function mapDispatchToProps(dispatch) {
  return {

    change_monthly_money_search_list(state) {
      dispatch(MonthlyMoney.change_monthly_money_search_list(state))
    },
    monthly_update(state) {
      dispatch(MonthlyMoney.monthly_update(state))
    },


  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);